import { readonly, ref } from "vue";
import { type LimitRefusal, readLimitRefusal } from "./limit-refusal";

/**
 * O ARMAZENAMENTO DO PLANO CHEIO, quando um upload bate nele — num lugar só.
 *
 * O mesmo desenho de `features/channels/api/channel-limit.ts`, um degrau acima:
 * lá as portas eram três e da mesma feature; aqui é TODA porta de upload — anexo
 * da conversa, arquivos, formulário, foto, marca, biblioteca, o chat do Ben — de
 * meia dúzia de features. Uma oferta por tela seria a mesma oferta escrita dez
 * vezes. Quem recusa é `POST /v3/files/upload` (400 `STORAGE_LIMIT`), as duas
 * funções que falam com ele anotam aqui, e a moldura (`App.vue`), que é a única
 * que pode ler a cobrança e não desmonta, desenha o diálogo.
 */
const refusal = ref<LimitRefusal | null>(null);

/** Guarda a recusa se ela foi por armazenamento cheio, e diz se foi. */
export function noteStorageLimit(e: unknown): boolean {
	const read = readLimitRefusal(e);
	if (read?.code !== "STORAGE_LIMIT") return false;
	refusal.value = read;
	return true;
}

/** A recusa à espera de resposta, e como a dispensar. */
export function useStorageLimit() {
	return {
		storageLimit: readonly(refusal),
		dismissStorageLimit: (): void => {
			refusal.value = null;
		},
	};
}
